export default (value = 0) => {
  return value * 100 + '%'
}
